/**
 * Utility function to get appropriate file icon based on file extension
 * @param {string} fileName - The name of the file including extension
 * @returns {string|null} - Returns the icon source (SVG data URL or image path) or null if no fileName
 */
export const getFileIcon = (fileName) => {
    if (!fileName) return null;
    
    const extension = fileName.split('.').pop().toLowerCase();
    
    switch (extension) {
        case 'pdf':
            return '/images/logo/pdficon.gif';
        case 'txt':
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMkgxNkMxNi44ODU2IDIgMTcuNSAyLjYxNDQ0IDE3LjUgMy41VjE2LjVDMTcuNSAxNy4zODU2IDE2Ljg4NTYgMTggMTYgMThINEMzLjExNDM4IDE4IDIuNSAxNy4zODU2IDIuNSAxNi41VjMuNUMyLjUgMi42MTQ0NCAzLjExNDM4IDIgNCAyWiIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8cGF0aCBkPSJNNS41IDcuNUgxNC41TTUuNSAxMC41SDE0LjVNNS41IDEzLjVIMTIuNSIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=';
        case 'jpg':
        case 'jpeg':
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMkMxLjg5NTQzIDIgMSAyLjg5NTQzIDEgNFYxNkMxIDE3LjEwNDYgMS44OTU0MyAxOCAzIDE4SDJIMThIMTdDMTguMTA0NiAxOCAxOSAxNy4xMDQ2IDE5IDE2VjRDMjAgMi44OTU0MyAxOS4xMDQ2IDIgMTggMkgzWiIgc3Ryb2tlPSIjRkY2QjAwIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8Y2lyY2xlIGN4PSI3IiBjeT0iNyIgcj0iMiIgZmlsbD0iI0ZGNkIwMCIvPgo8cGF0aCBkPSJNMTMgMTdMMTcgMTNMOSAxM0w3IDE1TDExIDE5TDEzIDE3WiIgc3Ryb2tlPSIjRkY2QjAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=';
        case 'png':
        case 'gif':
        case 'bmp':
        case 'svg':
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgMkMxLjg5NTQzIDIgMSAyLjg5NTQzIDEgNFYxNkMxIDE3LjEwNDYgMS44OTU0MyAxOCAzIDE4SDJIMThIMTdDMTguMTA0NiAxOCAxOSAxNy4xMDQ2IDE5IDE2VjRDMjAgMi44OTU0MyAxOS4xMDQ2IDIgMTggMkgzWiIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8Y2lyY2xlIGN4PSI3IiBjeT0iNyIgcj0iMiIgZmlsbD0iIzY2NjY2NiIvPgo8cGF0aCBkPSJNMTMgMTdMMTcgMTNMOSAxM0w3IDE1TDExIDE5TDEzIDE3WiIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=';
        case 'doc':
        case 'docx':
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMkgxNkMxNi44ODU2IDIgMTcuNSAyLjYxNDQ0IDE3LjUgMy41VjE2LjVDMTcuNSAxNy4zODU2IDE2Ljg4NTYgMTggMTYgMThINEMzLjExNDM4IDE4IDIuNSAxNy4zODU2IDIuNSAxNi41VjMuNUMyLjUgMi42MTQ0NCAzLjExNDM4IDIgNCAyWiIgc3Ryb2tlPSIjMDA3QkZGIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8cGF0aCBkPSJNNS41IDcuNUgxNC41TTUuNSAxMC41SDE0LjVNNS41IDEzLjVIMTIuNSIgc3Ryb2tlPSIjMDA3QkZGIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=';
        case 'xls':
        case 'xlsx':
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMkgxNkMxNi44ODU2IDIgMTcuNSAyLjYxNDQ0IDE3LjUgMy41VjE2LjVDMTcuNSAxNy4zODU2IDE2Ljg4NTYgMTggMTYgMThINEMzLjExNDM4IDE4IDIuNSAxNy4zODU2IDIuNSAxNi41VjMuNUMyLjUgMi42MTQ0NCAzLjExNDM4IDIgNCAyWiIgc3Ryb2tlPSIjMjE4NzM4IiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8cGF0aCBkPSJNNS41IDcuNUgxNC41TTUuNSAxMC41SDE0LjVNNS41IDEzLjVIMTIuNSIgc3Ryb2tlPSIjMjE4NzM4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=';
        default:
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQgMkgxNkMxNi44ODU2IDIgMTcuNSAyLjYxNDQ0IDE3LjUgMy41VjE2LjVDMTcuNSAxNy4zODU2IDE2Ljg4NTYgMTggMTYgMThINEMzLjExNDM4IDE4IDIuNSAxNy4zODU2IDIuNSAxNi41VjMuNUMyLjUgMi42MTQ0NCAzLjExNDM4IDIgNCAyWiIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8cGF0aCBkPSJNNS41IDcuNUgxNC41TTUuNSAxMC41SDE0LjVNNS41IDEzLjVIMTIuNSIgc3Ryb2tlPSIjNjY2NjY2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=';
    }
};

/**
 * Helper function to get file extension from filename
 * @param {string} fileName - The name of the file including extension
 * @returns {string} - Returns the file extension in lowercase
 */
export const getFileExtension = (fileName) => {
    if (!fileName) return '';
    return fileName.split('.').pop().toLowerCase();
};

/**
 * Helper function to check if file is an image
 * @param {string} fileName - The name of the file including extension
 * @returns {boolean} - Returns true if file is an image
 */
export const isImageFile = (fileName) => {
    const extension = getFileExtension(fileName);
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'].includes(extension);
};

/**
 * Helper function to check if file is a document
 * @param {string} fileName - The name of the file including extension
 * @returns {boolean} - Returns true if file is a document
 */
export const isDocumentFile = (fileName) => {
    const extension = getFileExtension(fileName);
    return ['pdf', 'doc', 'docx', 'txt'].includes(extension);
};

/**
 * Helper function to check if file is a spreadsheet
 * @param {string} fileName - The name of the file including extension
 * @returns {boolean} - Returns true if file is a spreadsheet
 */
export const isSpreadsheetFile = (fileName) => {
    const extension = getFileExtension(fileName);
    return ['xls', 'xlsx'].includes(extension);
};
